import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { Users, Mail, MessageSquare, Database, Globe, Sheet, Calendar, CreditCard, Share2 } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { IntegrationNodeData } from '../../types/nodes';

const integrationIcons = {
  crm: <Users />,
  email: <Mail />,
  sms: <MessageSquare />,
  database: <Database />,
  api_call: <Globe />,
  google_sheets: <Sheet />,
  calendar: <Calendar />,
  payment_gateway: <CreditCard />,
  social_media: <Share2 />
};

const integrationLabels = {
  crm: 'CRM',
  email: 'Email',
  sms: 'SMS',
  database: 'Database',
  api_call: 'Chiamata API',
  google_sheets: 'Google Sheets',
  calendar: 'Calendario',
  payment_gateway: 'Gateway Pagamento',
  social_media: 'Social Media'
};

const IntegrationNode: React.FC<NodeProps<IntegrationNodeData>> = memo(({ selected, data }) => {
  const icon = integrationIcons[data.integrationType] || <Globe />;
  const label = integrationLabels[data.integrationType] || 'Integrazione';
  
  const getPreview = () => {
    switch (data.integrationType) {
      case 'crm':
        return data.config.crmType || 'CRM generico';
      case 'email':
        return data.config.emailTo || 'Nessun destinatario';
      case 'sms':
        return data.config.smsTo || 'Nessun numero';
      case 'database':
        return data.config.databaseAction || 'Query';
      case 'api_call':
        return data.config.apiMethod || 'GET';
      case 'google_sheets':
        return data.config.sheetsRange || 'A1:Z100';
      case 'calendar':
        return 'Evento calendario';
      case 'payment_gateway':
        return data.config.paymentCurrency || 'EUR';
      case 'social_media':
        return data.config.socialPlatform || 'Facebook';
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-orange-500 to-red-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

IntegrationNode.displayName = 'IntegrationNode';

export default IntegrationNode;
